var mooImgUrl, mooTitle, mooDesc, mooShareUrl;
var herMoo;

/*
 * Helper fns.
 * */
function storeMoo(data) {
  window.localStorage
    ? window.localStorage.setItem('moo', JSON.stringify(data))
    : 0;
}
function fetchMoo() {
  var storedMoo = window.localStorage
    ? JSON.parse(window.localStorage.getItem('moo'))
    : null;
  return storedMoo;
}

function randBwZeroTo(length) {
  return Math.floor(Math.random(0, 1) * length);
}

/*
 * Data needed by popup
 * */
function constructModalData(data) {
  mooTitle = data.fname + ' ' + data.lname;
  mooTitle = mooTitle.replace(/\b\w/g, function(l) {
    return l.toUpperCase();
  });
  mooDesc =
    mooDb.fnames[data.fname] + ', ' + mooTitle + ' ' + mooDb.lnames[data.lname];
  mooShareUrl =
    window.location.origin +
    '/cryptocows/' +
    data.fname +
    '-' +
    data.lname +
    '-' +
    data.imgTag +
    '/';
  mooImgUrl = 'cow-' + data.imgTag;
}

function makeNewMoo(time) {
  var fnamekeys = Object.keys(mooDb.fnames);
  var lnamekeys = Object.keys(mooDb.lnames);

  var fname = fnamekeys[randBwZeroTo(fnamekeys.length)];
  var lname = lnamekeys[randBwZeroTo(lnamekeys.length)];
  var imgTag = randBwZeroTo(mooDb.cows.length) + 1; // default is 0 to length;

  if (herMoo && herMoo.imgTag === imgTag) {
    imgTag = randBwZeroTo(mooDb.cows.length) + 1; // Generate again to avoid same image as user got before;
  }

  var data = {
    fname: fname,
    lname: lname,
    imgTag: imgTag
  };

  constructModalData(data);

  data = Object.assign(data, { time: time });
  storeMoo(data);
}

function getHerMoo() {
  herMoo = fetchMoo();
  var time = new Date().getTime();

  if (herMoo && herMoo.time && herMoo.fname) {
    // Repeated user
    var timeElapsed = time - herMoo.time;
    // Make New moo after every 10 minutes
    if (timeElapsed > 60000) {
      makeNewMoo(time);
    } else {
      var data = {
        fname: herMoo.fname,
        lname: herMoo.lname,
        imgTag: herMoo.imgTag
      };
      constructModalData(data);
    }
  } else {
    // First time user
    makeNewMoo(time);
  }
}

$('.btn-moo.assign-moo').click(function() {
  getHerMoo();
  setTimeout(function() {
    openModal('#assign-moo-modal');
    $('#moo-img').attr('src', '/assets/cryptocows/cows/' + mooImgUrl + '.png');
    $('#header-title').html(mooTitle);
    $('.desc#moo-desc').html(mooDesc);
  }, 150);
});

$('#getNewCow').click(function(e) {
  e.preventDefault();
  makeNewMoo(Date.now());

  // Make the width of the image fixed, so that the content doesn't shift while image is loading.
  var width = $('#moo-img').innerWidth();
  if (width > 0.0) {
    $('#moo-img').css('width', width + 'px');
  }

  $('#moo-img').attr('src', '/assets/cryptocows/cows/' + mooImgUrl + '.png');
  $('#header-title').html(mooTitle);
  $('.desc#moo-desc').html(mooDesc);
});

var fbBase = 'https://www.facebook.com/sharer/sharer.php?u=';
var twitterBase = 'https://twitter.com/share?url=';
var linkedinBase = 'http://www.linkedin.com/shareArticle?mini=true&url=';
var whatsappBase = 'whatsapp://send?text=';

var shareMessage = encodeURIComponent(
  'Get your very own #CryptoCashCow this Financial Year, built on @Razorpay’s brand new #cryptocurrency. Do it before your annoying coworkers start talking about it! $GST'
);

$('#fb-share').click(function() {
  var completeShareMessage =
    encodeURIComponent(mooTitle + ' is my CryptoCow. ') + shareMessage;
  window.open(
    fbBase +
      mooShareUrl +
      '&quote=' +
      completeShareMessage +
      '&hashtag=%23CryptoCashCow',
    'facebook-share',
    'width=550,height=235'
  );
  return false;
});

$('#twitter-share').click(function() {
  var completeShareMessage =
    encodeURIComponent(mooTitle + ' is my CryptoCow. ') + shareMessage;
  window.open(
    twitterBase + mooShareUrl + '&text=' + completeShareMessage,
    'twitter-share',
    'width=550,height=235'
  );
  return false;
});

$('#linkedin-share').click(function() {
  var completeShareMessage =
    encodeURIComponent(mooTitle + ' is my CryptoCow. ') + shareMessage;
  window.open(
    linkedinBase + mooShareUrl + '&title=' + completeShareMessage,
    'linkedin-share',
    'width=550,height=235'
  );
  return false;
});

$('#whatsapp-share').click(function() {
  var completeShareMessage =
    mooTitle +
    ' is my CryptoCow. ' +
    mooDesc +
    ' ' +
    shareMessage +
    ' ' +
    mooShareUrl;
  window.open(whatsappBase + completeShareMessage);
  return false;
});
